// import "./FeaturCard.scss";

function FeaturCard({ title, color, description, image, align }) {
  return (
    <div className="feature-card-holder">
      <div
        className={`feature-card-content`}
        style={{ backgroundColor: color }}
      >
        <img src={image} alt="" />
      </div>
      <div>
        <h4 className="feature-card--title">{title}</h4>
        <p className="feature-card--desc">{description}</p>
      </div>
    </div>
  );
}

export default FeaturCard;
